import {
    isFunction,
    isNonEmptyObject
} from "@tomeravni/easybizy-js-common/common";
import {DEFAULT_PROGRESS} from "./constants";


export const configToProgress = (config, paymentType) => {
    const toReturn = DEFAULT_PROGRESS.slice().filter((item) => {
        return (config.AllowPickingEmployees || item.label !== 'schedule.progressEmployee') &&
            (config.PaymentsRequired || item.label !== 'schedule.payment');
    });

    // if (paymentType === PAYMENT_TYPE.VALIDATE && isNonEmptyArray(toReturn) && 'schedule.payment' === toReturn[toReturn.length - 1].label) {
    //     toReturn[toReturn.length - 1] = Object.assign({}, toReturn[toReturn.length - 1], {label: 'validation_payment'})
    // }

    return toReturn;
};

export const setProgressValueByKey = (state, key, value, translateName = false, config) => {
    let progress = state.progress ? state.progress : configToProgress(config || state.config, state.paymentType);
    if (progress.asMutable) {
        progress = progress.asMutable();
    }

    if (!key) {
        return progress;
    }

    let progressStepIndex = progress.findIndex(p => p.label === key);
    if (progressStepIndex < 0) {
        return progress;
    }

    let currentPhase = progress[progressStepIndex];
    if (isNonEmptyObject(currentPhase)) {
        if (isFunction(currentPhase.set)) {
            progress[progressStepIndex] = currentPhase.set('value', value).set('translateName', translateName);
        } else {
            progress[progressStepIndex] = {...currentPhase, value, translateName};
        }
    }

    return progress;
}
